import React, { useState, useEffect } from 'react';
import { useIntl, getLocale, history } from 'umi';
import { Table, Segment, notification } from 'tea-component';
import './index.scss';
import NoData from '@/pages/intelligence/components/NoData';
import {
  TableCheckboxHeader,
  TableCheckboxRender,
} from '@/pages/intelligence/components/TableComponents/components/TableCheckbox';
import SortBy from '@/pages/intelligence/components/TableComponents/components/SortBy';
import TableShowData from '@/pages/intelligence/components/TableComponents/components/TableShowData';
import { formatNum, formatPercentNum, addV2Prefix } from '@/pages/intelligence/utils/commonUtils';
import { DataSourceBubbleContent } from '@/pages/intelligence/components/DataSourceBubbleContent';
import global from '@/pages/intelligence/assets/svg/flag/global.svg';
import defaultIcon from '@/pages/intelligence/assets/svg/flag/default.svg';
import { buriedBtnPoint } from '@/pages/home/utils/buriedPoint';
import { dbiBtnLogMes } from '@/pages/intelligence/utils/buriedPointCfg';
import MscienceIcon from '@/pages/intelligence/assets/svg/dataSource/mscience-bg.svg';
import Npdicon from '@/pages/intelligence/assets/svg/dataSource/npd-icon.svg';
// import NewzooIcon from '@/pages/home/assets/svg/dataSource/databarin.svg';
// import NewzooIcon from '@/pages/intelligence/assets/svg/dataSource/newzoo-bg.svg';
import NewzooIcon from '@/pages/intelligence/assets/svg/dataSource/databarin-gray.svg';
import CloumsCenter from '@/pages/intelligence/components/TableComponents/components/CloumsCenter';
import ARightClickToJump from '@/pages/intelligence/components/ARightClickToJump';
const { selectable, pageable, sortable, scrollable, autotip } = Table.addons;

export default function PCTable(props: any) {
  const {
    pageId,
    tableData,
    selectedKeys,
    selectAllKeys,
    changeMarketProfileAll,
    changeChartType,
    changeMpTableSort,
    sortColunms,
    changeSelectedKeys,
    yearData,
    regionsCountries,
    entityType,
  } = props;
  const { formatMessage } = useIntl();
  const allMarkets = regionsCountries?.map((area: any) => area.country_set).flat() || [];
  const isEN = getLocale() === 'en-US';

  // 表格列表项选择事件回调
  const onTableCheckGame = (selectList: any) => {
    changeSelectedKeys(selectList);
    changeChartType('discount-chart');
  };

  // 跳转到游戏详情
  const gotoDetailsPage = (val: any, jump = true) => {
    const path = `/intelligence/MarketProfile/Overview/detail?marketName=${val.marketName}&marketNameEn=${val.marketNameEn}&pageId=${pageId}`;
    if (jump) {
      buriedBtnPoint({
        ...dbiBtnLogMes[
          pageId === 'MarketProfilPC'
            ? 'marketProfilePCClickMarket'
            : 'marketProfileConsoleClickMarket'
        ],
        extInfo: val.marketName,
      });
      return history.push(path);
    }
    return path;
  };

  const pcColumns = [
    {
      key: 'select',
      width: 37,
      fixed: 'left',
      header: () => (
        <TableCheckboxHeader
          selectList={selectedKeys}
          tableSelectionAll={selectAllKeys}
          // disabled={loading || records.length === 0}
          onChange={(params, type) => {
            changeMarketProfileAll({ type });
            // notification.success({
            //   description: 'Switched to line chart.',
            // });
          }}
        />
      ),
      render: (cvm: any) => (
        <TableCheckboxRender
          selectList={selectedKeys}
          cvm={{ ...(cvm || {}), gameId: cvm?.marketName }}
          onChange={(list, status) => {
            onTableCheckGame(list, status);
            // notification.success({
            //   description: 'Switched to line chart.',
            // });
          }}
        />
      ),
    },
    {
      key: 'marketName',
      width: 200,
      fixed: 'left',
      header: (
        <div className="dbi-marketprofile-table-title">
          <span>#</span> {formatMessage({ id: 'dbi_market' })}
        </div>
      ),
      render: (item: any) => {
        const href = gotoDetailsPage(item, false);
        return (
          <ARightClickToJump href={addV2Prefix(href)} style={{ display: 'inline' }}>
            <div
              className="dbi-marketprofile-table-cont"
              onClick={() => {
                if (item.marketNameEn != 'global' && item.marketNameEn != 'global_wo_china') {
                  gotoDetailsPage(item);
                }
              }}
            >
              <span className="dbi-marketprofile-table-rank">{item?.rank}</span>
              <div className="dbi-marketprofile-table-img">
                {item.marketFlag ? (
                  <img
                    className={
                      item.marketNameEn != 'global' && item.marketNameEn != 'global_wo_china'
                        ? 'normalFlag'
                        : 'globalFlag'
                    }
                    src={item.marketFlag}
                    onError={(e: any) => {
                      e.target.onerror = null;
                      if (item.marketNameEn.indexOf('global') != -1) {
                        e.target.src = global;
                      } else {
                        e.target.src = defaultIcon;
                      }
                    }}
                  />
                ) : (
                  <></>
                )}
              </div>
              <span
                className={`dbi-marketprofile-table-text ${
                  item.marketNameEn != 'global' && item.marketNameEn != 'global_wo_china'
                    ? 'hover-style'
                    : ''
                }`}
              >
                {allMarkets?.find((market: any) => market.country_code === item.marketNameEn)?.[
                  isEN ? 'country_name_en' : 'country_name_ch'
                ] || item.marketName}
              </span>
            </div>
          </ARightClickToJump>
        );
      },
    },
    {
      key: 'marketDigitalRevenue',
      header: () => (
        <CloumsCenter width={220} align={'right'}>
          <SortBy
            type="font_sort"
            filter={changeMpTableSort}
            defaultKey={sortColunms[0]}
            defaultValue={'desc'}
            title={formatMessage({ id: 'dbi_metric_digitalRevenue' })}
            svgTip={
              <DataSourceBubbleContent
                sourceNameLocalId={formatMessage({
                  id: 'dbi_metric_digitalRevenue',
                })}
                metric={'mscience'}
                metricKey={'digitalRevenue'}
                entityType={entityType}
              />
            }
            svgIcon={MscienceIcon}
            content={formatMessage({ id: 'dbi_info_sum_selected' })}
            list={[
              {
                key: `digital`,
                sortMetric: '',
                orderSource: 'mscience',
                text: formatMessage({ id: 'dbi_revenue_$' }),
                title: formatMessage({ id: 'dbi_metric_digitalRevenue' }),
                ratioType: 0,
              },
              {
                key: `digitalChange`,
                sortMetric: '',
                orderSource: 'mscience',
                text: `${formatMessage({
                  id: 'dbi_revenue_$',
                })}:${formatMessage({ id: 'dbi_change' })}(%)`,
                title: `${formatMessage({
                  id: 'dbi_metric_digitalRevenue',
                })}%`,
                ratioType: 1,
              },
            ]}
          />
        </CloumsCenter>
      ),
      align: 'center',
      width: 280,
      render: (item: any) => (
        <CloumsCenter width={220} align={'right'}>
          <div className="dbi-marketprofile-table-end">
            <TableShowData
              value={item.marketDigitalRevenue === 0 ? '-' : formatNum(item.marketDigitalRevenue, true)}
              type={item.marketDigitalRevenuePrecent ? (item.marketDigitalRevenuePrecent < 0 ? 'down' : 'up') : '-'}
              growth={!item.marketDigitalRevenuePrecent ? '-' : formatPercentNum(item.marketDigitalRevenuePrecent)}
            />
          </div>
        </CloumsCenter>
      ),
    },
    {
      key: 'marketPhysicalRevenue',
      header: () => (
        <SortBy
          type="font_sort"
          filter={changeMpTableSort}
          title={formatMessage({ id: 'dbi_metric_physical_revenue' })}
          defaultKey={sortColunms[0]}
          defaultValue={'desc'}
          svgIcon={Npdicon}
          svgTip={
            <DataSourceBubbleContent
              sourceNameLocalId={formatMessage({
                id: 'dbi_metric_physical_revenue',
              })}
              metric={'npd'}
              metricKey={'physical_revenue'}
              entityType={entityType}
            />
          }
          content={formatMessage({ id: 'dbi_info_sum_selected' })}
          list={[
            {
              key: `physical`,
              sortMetric: '',
              orderSource: 'npd',
              text: formatMessage({ id: 'dbi_revenue_$' }),
              title: formatMessage({ id: 'dbi_metric_physical_revenue' }),
              ratioType: 0,
            },
            {
              key: `physicalChange`,
              sortMetric: '',
              orderSource: 'npd',
              text: `${formatMessage({
                id: 'dbi_revenue_$',
              })}:${formatMessage({ id: 'dbi_change' })}(%)`,
              title: `${formatMessage({
                id: 'dbi_metric_physical_revenue',
              })}(%)`,
              ratioType: 1,
            },
          ]}
        />
      ),
      align: 'center',
      width: 250,
      render: (item: any) => (
        <div className="dbi-marketprofile-table-end">
          <TableShowData
            value={item.marketPhysicalRevenue === 0 ? '-' : formatNum(item.marketPhysicalRevenue, true)}
            type={item.marketPhysicalRevenuePrecent ? (item.marketPhysicalRevenuePrecent < 0 ? 'down' : 'up') : '-'}
            growth={!item.marketPhysicalRevenuePrecent ? '-' : formatPercentNum(item.marketPhysicalRevenuePrecent)}
          />
        </div>
      ),
    },
    {
      key: pageId == 'MarketProfilPC' ? 'pcRevenue' : 'consoleRevenue',
      header: () => (
        <SortBy
          type="font_sort"
          filter={changeMpTableSort}
          title={`${formatMessage({ id: 'dbi_total_rev' })}(${yearData})`}
          defaultKey={sortColunms[0]}
          defaultValue={'desc'}
          svgIcon={NewzooIcon}
          svgTip={
            <DataSourceBubbleContent
              sourceNameLocalId={formatMessage({ id: 'dbi_total_rev' })}
              metric={'newzoo'}
              metricKey={'total revenue'}
              entityType={entityType}
            />
          }
          content={formatMessage({ id: 'dbi_market_newzoo_rev' })}
          list={[
            {
              key: `totalRevenue`,
              orderSource: 'npd',
              text: `${formatMessage({ id: 'dbi_total_rev' })}(${yearData})`,
              title: `${formatMessage({ id: 'dbi_total_rev' })}(${yearData})`,
              ratioType: 0,
            },
          ]}
        />
      ),
      align: 'right',
      width: 340,
    },
    {
      key: pageId == 'MarketProfilPC' ? 'pcPlayer' : 'consolePlayer',
      header: () => (
        <SortBy
          type="font_sort"
          filter={changeMpTableSort}
          title={`${formatMessage({ id: 'dbi_total_player' })}(${yearData})`}
          defaultKey={sortColunms[0]}
          defaultValue={'desc'}
          svgIcon={NewzooIcon}
          svgTip={
            <DataSourceBubbleContent
              sourceNameLocalId={formatMessage({ id: 'dbi_total_player' })}
              metric={'newzoo'}
              metricKey={'total player'}
              entityType={entityType}
            />
          }
          content={formatMessage({ id: 'dbi_market_newzoo_player' })}
          list={[
            {
              key: `totalPlayer`,
              sortMetric: '',
              orderSource: 'newzoo',
              text: `${formatMessage({
                id: 'dbi_total_player',
              })}(${yearData})`,
              title: `${formatMessage({
                id: 'dbi_total_player',
              })}(${yearData})`,
              ratioType: 0,
            },
          ]}
        />
      ),
      align: 'right',
      width: 320,
    },
    {
      key: 'settings',
      header: (
        <CloumsCenter width={100} align={'left'} titleStyle={true}>
          {formatMessage({ id: 'dbi_actions' })}
        </CloumsCenter>
      ),
      align: 'center',
      width: 200,
      render: (item: any) => (
        <CloumsCenter width={100} align={'left'}>
          {item.marketNameEn == 'global' || item.marketNameEn == 'global_wo_china' ? (
            '-'
          ) : (
            <div
              className={'dbi-marketprofile-table-details'}
              onClick={() => {
                if (item.marketNameEn != 'global' && item.marketNameEn != 'global_wo_china') {
                  buriedBtnPoint({
                    ...dbiBtnLogMes[
                      pageId === 'MarketProfilPC'
                        ? 'marketProfilePCClickMarket'
                        : 'marketProfileConsoleClickMarket'
                    ],
                    extInfo: item.marketName,
                  });
                  history.push({
                    pathname: '/intelligence/MarketProfile/Overview/detail',
                    query: {
                      marketName: item.marketName,
                      marketNameEn: item.marketNameEn,
                      pageId,
                    },
                  });
                }
              }}
            >
              {formatMessage({ id: 'dbi_details' })}
            </div>
          )}
        </CloumsCenter>
      ),
    },
  ];

  return (
    <Table
      className="tablecard-box dbi-table-selectable dbi-table-sticky"
      bordered="all"
      records={tableData || []}
      columns={pcColumns}
      addons={[
        pageable(),
        scrollable({
          minWidth: 400,
        }),
        autotip({
          isError: tableData.length === 0,
          errorText: <NoData content={formatMessage({ id: 'common_nodata' })} />,
        }),
      ]}
    />
  );
}
